<div class="theme-selector">
  <label for="theme-dropdown">Tema:</label>
  <select
    id="theme-dropdown"
    [ngModel]="selectedScheme"
    (ngModelChange)="onSchemeChange($event)"
  >
    <option *ngFor="let scheme of colorSchemes" [value]="scheme.value">{{ scheme.label }}</option>
  </select>
</div>
